'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _contactLink = require('common/components/contact-link');

var _contactLink2 = _interopRequireDefault(_contactLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function (_React$Component) {
    _inherits(DocusignSwitch, _React$Component);

    function DocusignSwitch() {
        _classCallCheck(this, DocusignSwitch);

        return _possibleConstructorReturn(this, (DocusignSwitch.__proto__ || Object.getPrototypeOf(DocusignSwitch)).apply(this, arguments));
    }

    _createClass(DocusignSwitch, [{
        key: 'render',
        value: function render() {
            var words = ['better', 'easier', 'friendly'];
            return _react2['default'].createElement(
                'div',
                { className: 'm-docusign-switch' },
                _react2['default'].createElement(
                    'header',
                    null,
                    _react2['default'].createElement(
                        'h1',
                        null,
                        'Say Hello to ',
                        _react2['default'].createElement(WordSlider, { words: words }),
                        ' eSignatures'
                    ),
                    _react2['default'].createElement(
                        'h2',
                        null,
                        'DocuSign',
                        '\xAE',
                        ' users, welcome to the future of eSigning'
                    ),
                    _react2['default'].createElement(
                        'a',
                        { href: '/info/pricing' },
                        _react2['default'].createElement(
                            'button',
                            { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
                            'SWITCH NOW'
                        )
                    )
                ),
                _react2['default'].createElement(
                    'section',
                    { className: 'm-docusign-switch__why-switch' },
                    _react2['default'].createElement(
                        'h2',
                        null,
                        'WHY SWITCH?'
                    ),
                    _react2['default'].createElement(
                        'section',
                        { className: 'm-docusign-switch__better-signing-experience' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'center-image-wrapper macbook' },
                            _react2['default'].createElement('img', { src: require('./assets/macbook_@2x.png'), 'aria-hidden': true })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__copy why-switch-copy' },
                            _react2['default'].createElement(
                                'h3',
                                null,
                                'Better signing experience for you and your customers.'
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'We\'ve created the ',
                                _react2['default'].createElement(
                                    'a',
                                    { target: '_blank', rel: 'noopener noreferrer',
                                        href: 'http://blog.hellosign.com/new-signer-experience/' },
                                    'most intuitive interface in the industry'
                                ),
                                ' without compromising on functionality. Our stream-lined, user-friendly design combined with powerful features won\u2019t disappoint you, your team, or your customers when it comes to signing important docs online. We don\u2019t believe in unnecessary clutter.'
                            )
                        )
                    ),
                    _react2['default'].createElement(
                        'section',
                        { className: 'm-docusign__easier-to-sign-anywhere' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'center-image-wrapper signer-experience-image-wrapper' },
                            _react2['default'].createElement('img', { src: require('./assets/signer_experience_@2x.png'), 'aria-hidden': true })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__copy sign-anywhere-copy' },
                            _react2['default'].createElement(
                                'h3',
                                null,
                                'Easier to sign anywhere, at any time, on any device.'
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Sometimes signing a document needs to happen at a moment\'s notice. Our responsive design allows you to request a signature or sign on-the-go. And with a ',
                                _react2['default'].createElement(
                                    'a',
                                    { target: '_blank', rel: 'noopener noreferrer',
                                        href: 'https://www.hellosign.com/info/tour' },
                                    'growing list of industry-first features'
                                ),
                                ' like our \'Insert Everywhere\' button and data validation, we\u2019re confident you\u2019ll love the experience.'
                            )
                        )
                    ),
                    _react2['default'].createElement(
                        'section',
                        { className: 'm-docusign-switch__features' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__features-row' },
                            _react2['default'].createElement(
                                'section',
                                null,
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'm-docusign-switch__copy' },
                                    _react2['default'].createElement('img', { src: require('./assets/feature_icons/support_icon_@2x.svg'),
                                        'aria-hidden': true,
                                        className: 'm-docusign-switch-support_icon' }),
                                    _react2['default'].createElement(
                                        'h3',
                                        null,
                                        'Best-in-class developer and user support.'
                                    ),
                                    _react2['default'].createElement(
                                        'p',
                                        null,
                                        'We understand that eSignatures power a critical piece of your business, so we take support very seriously. Our expert support team is devoted to helping you get the most value out of eSignatures. We also have a specialized API support team which means the person that helped integrate eSignatures into your product will be the same person you can come to for questions.'
                                    )
                                )
                            ),
                            _react2['default'].createElement(
                                'section',
                                null,
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'm-docusign-switch__copy integrate-copy' },
                                    _react2['default'].createElement('img', { src: require('./assets/feature_icons/integrate_icon.svg'),
                                        'aria-hidden': true,
                                        className: 'm-docusign-switch-integrate_icon' }),
                                    _react2['default'].createElement(
                                        'h3',
                                        null,
                                        'Integrate eSignatures with anything, faster.'
                                    ),
                                    _react2['default'].createElement(
                                        'p',
                                        null,
                                        'Want to integrate eSignatures into your own apps or site?',
                                        _react2['default'].createElement(
                                            'a',
                                            { href: 'https://www.hellosign.com/api', target: '_blank', rel: 'noopener noreferrer' },
                                            ' Our API '
                                        ),
                                        'makes that a cinch too. Our eSignature API is designed with ',
                                        _react2['default'].createElement(
                                            'a',
                                            { target: '_blank',
                                                href: 'http://blog.hellosign.com/the-rise-of-developer-experience/' },
                                            'developer experience top of mind'
                                        ),
                                        '. We offer a variety of ways to integrate a signing flow directly into your site and the highest level of customization available in the industry with our ',
                                        _react2['default'].createElement(
                                            'a',
                                            { target: '_blank', rel: 'noopener noreferrer',
                                                href: 'https://www.hellosign.com/api/white-labeling' },
                                            'white labeling functionality'
                                        ),
                                        '. We believe in making eSignatures feel like a seemless part of your product.'
                                    )
                                )
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__features-row' },
                            _react2['default'].createElement(
                                'section',
                                { className: 'copy-shift' },
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'm-docusign-switch__copy' },
                                    _react2['default'].createElement('img', { src: require('./assets/feature_icons/pricing_icon_@2x.png'),
                                        'aria-hidden': true,
                                        className: 'm-docusign-switch-pricing_icon' }),
                                    _react2['default'].createElement(
                                        'h3',
                                        null,
                                        'Transparent pricing. No hidden fees. No hassle.'
                                    ),
                                    _react2['default'].createElement(
                                        'p',
                                        null,
                                        'Unlike DocuSign, we offer transparent pricing from the get go. That means no hidden fees and no unexpected price hikes. DocuSign users are often surprised by unexplained fees or charges. You\'ll be happy to hear we\u2019ll never surprise you with pricing \u2014 we\u2019re just not really into that kind of thing.'
                                    )
                                )
                            ),
                            _react2['default'].createElement(
                                'section',
                                null,
                                _react2['default'].createElement(
                                    'div',
                                    { className: 'm-docusign-switch__copy modern-tools-copy' },
                                    _react2['default'].createElement('img', { src: require('./assets/feature_icons/modern_tools_icon.svg'),
                                        'aria-hidden': true,
                                        className: 'm-docusign-switch-pricing_icon' }),
                                    _react2['default'].createElement(
                                        'h3',
                                        null,
                                        'Sync eSignatures with your favorite modern tools.'
                                    ),
                                    _react2['default'].createElement(
                                        'p',
                                        null,
                                        'We integrate with all your favorite apps. Easily pull files from your cloud storage account into HelloSign, or send a signature request directly from Dropbox, OneDrive, or Box. Sign a document right from Gmail with one click \u2014 we work seamlessly with Google Apps. Keep up to date with actionable eSignature updates in Slack and Hubspot CRM. You can even access all of your Evernote documents in HelloSign.'
                                    )
                                )
                            )
                        ),
                        _react2['default'].createElement(
                            'section',
                            { className: 'pricing-button' },
                            _react2['default'].createElement(
                                'a',
                                { href: '/info/pricing' },
                                _react2['default'].createElement(
                                    'button',
                                    { className: 'bg-cerulean c-white hc-white hbg-velvet-evening' },
                                    'SEE PRICING'
                                )
                            )
                        )
                    )
                ),
                _react2['default'].createElement(
                    'section',
                    { className: 'm-docusign-switch__api-container' },
                    _react2['default'].createElement(
                        'h2',
                        null,
                        'See how HelloSign\'s eSignature API compares to Docusign API'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-docusign-switch__api-icons-container' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__api-container__icon-container' },
                            _react2['default'].createElement('img', { src: require('./assets/api_icons/api_clock_icon.svg'),
                                'aria-hidden': true }),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Accept eSignatures in minutes'
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__api-container__icon-container' },
                            _react2['default'].createElement('img', { src: require('./assets/api_icons/api_free_icon.svg'),
                                'aria-hidden': true }),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Free during development'
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__api-container__icon-container' },
                            _react2['default'].createElement('img', { src: require('./assets/api_icons/api_docs_icon.svg'),
                                className: 'docs-icon',
                                'aria-hidden': true }),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Clean Documentation'
                            )
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__api-container__icon-container' },
                            _react2['default'].createElement('img', { src: require('./assets/api_icons/api_dashboard_icon.svg'),
                                className: 'docs-icon',
                                'aria-hidden': true }),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Industry-first API Dashboard'
                            )
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        null,
                        _react2['default'].createElement(
                            'a',
                            { href: '/api/hellosign-vs-docusign' },
                            _react2['default'].createElement(
                                'button',
                                { className: 'bg-goldenrod hc-goldenrod border-1-goldenrod hbg-white c-white' },
                                'LEARN MORE'
                            )
                        )
                    )
                ),
                _react2['default'].createElement(
                    'section',
                    { className: 'm-docusign-switch__happy-customers' },
                    _react2['default'].createElement(
                        'h2',
                        null,
                        'HAPPY HELLOSIGN CUSTOMERS'
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-docusign-switch__logos-container' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__happy-customer__intuit' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/intuit_logo_@2x.png'), 'aria-hidden': true })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__happy-customer__instacart' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/instacart_logo_@2x.png'), 'aria-hidden': true })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__happy-customer__lyft' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/lyft_logo_@2x.png'), 'aria-hidden': true })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__happy-customer__samsung' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/samsung_logo_@2x.png'), 'aria-hidden': true })
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'm-docusign-switch__happy-customer__twitter' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/twitter_logo_@2x.png'), 'aria-hidden': true })
                        )
                    )
                ),
                _react2['default'].createElement(
                    'section',
                    { className: 'm-docusign-switch__case-studies' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'case-study-header' },
                        _react2['default'].createElement(
                            'h2',
                            null,
                            'CASE STUDIES'
                        )
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-docusign-switch__case-studies-container' },
                        _react2['default'].createElement(
                            'section',
                            { className: 'm-docusign-switch__case-study openlegal' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/openlegal_logo.png'), 'aria-hidden': true }),
                            _react2['default'].createElement(
                                'h4',
                                null,
                                'Law startup Openlegal reduced administrative costs by 30-50% with HelloSign.'
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                '\'[HelloSign] syncs to Google Drive, Dropbox, etc. which means we can often access documents without having to open up HelloSign.\''
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Ric Gruber, Partner, ',
                                _react2['default'].createElement(
                                    'strong',
                                    null,
                                    'Openlegal'
                                )
                            ),
                            _react2['default'].createElement(
                                'div',
                                { className: 'case-study-learn-more' },
                                _react2['default'].createElement(
                                    'a',
                                    { href: 'http://info.hellosign.com/openlegal-case-study.html', target: '_blank', rel: 'noopener noreferrer' },
                                    'LEARN MORE'
                                )
                            )
                        ),
                        _react2['default'].createElement('div', { className: 'm-docusign-switch__case-study-border' }),
                        _react2['default'].createElement(
                            'section',
                            { className: 'm-docusign-switch__case-study trxade' },
                            _react2['default'].createElement('img', { src: require('./assets/logos/trxade_logo.png'), 'aria-hidden': true }),
                            _react2['default'].createElement(
                                'h4',
                                null,
                                'When their eSignature provider hiked their rates more than 400%, pharmacy platform Trxade switched to HelloSign\'s API in days.'
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                '\'My biggest liking about HelloSign was just the ease. We used some of your advanced functionality right off the bat and it was really quick to implement and that was really nice.\''
                            ),
                            _react2['default'].createElement(
                                'p',
                                null,
                                'Jeff Davis, CTO, ',
                                _react2['default'].createElement(
                                    'strong',
                                    null,
                                    'Trxade'
                                )
                            ),
                            _react2['default'].createElement(
                                'div',
                                { className: 'case-study-learn-more' },
                                _react2['default'].createElement(
                                    'a',
                                    { href: 'http://info.hellosign.com/trxade-case-study.html', target: '_blank', rel: 'noopener noreferrer' },
                                    'LEARN MORE'
                                )
                            )
                        )
                    )
                ),
                _react2['default'].createElement(
                    'footer',
                    null,
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-docusign-switch__footer-left' },
                        _react2['default'].createElement(
                            'a',
                            { href: '/info/aboutUs', target: '_blank', rel: 'noopener noreferrer' },
                            'About HelloSign'
                        ),
                        _react2['default'].createElement(_contactLink2['default'], null)
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-docusign-switch__footer-right' },
                        _react2['default'].createElement(
                            'span',
                            { className: 'hs-copyright' },
                            'HelloSign ',
                            '\xA9',
                            ' 2016'
                        )
                    )
                )
            );
        }
    }]);

    return DocusignSwitch;
}(_react2['default'].Component);

var WordSlider = function (_React$Component2) {
    _inherits(WordSlider, _React$Component2);

    function WordSlider(props) {
        _classCallCheck(this, WordSlider);

        var _this2 = _possibleConstructorReturn(this, (WordSlider.__proto__ || Object.getPrototypeOf(WordSlider)).call(this, props));

        _this2.timeouts = [];
        _this2.state = {
            currentWordIndex: 0,
            animation: 'animate-in'
        };
        return _this2;
    }

    _createClass(WordSlider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initiateAnimateOut();
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
            this.timeouts = [];
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'initiateAnimateOut',
        value: function initiateAnimateOut() {
            var _this3 = this;

            this.timeouts.push(setTimeout(function () {
                return _this3.animateOut();
            }, 3000));
        }
    }, {
        key: 'animateOut',
        value: function animateOut() {
            var _this4 = this;

            this.setState({ animation: 'animate-out' });
            this.timeouts.push(setTimeout(function () {
                return _this4.incrementIndex();
            }, 320));
        }
    }, {
        key: 'incrementIndex',
        value: function incrementIndex() {
            var currentWordIndex = this.state.currentWordIndex;
            if (currentWordIndex < this.props.words.length - 1) currentWordIndex++;else currentWordIndex = 0;
            this.initiateAnimateOut();
            this.setState({
                currentWordIndex: currentWordIndex,
                animation: 'animate-in'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var currentWord = this.props.words[this.state.currentWordIndex];
            var classes = 'slider-text ' + this.state.animation;
            return _react2['default'].createElement(
                'span',
                { className: classes },
                currentWord
            );
        }
    }]);

    return WordSlider;
}(_react2['default'].Component);


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/docusign-switch/index.jsx
 ** module id = 1532
 ** module chunks = 0
 **/